import React from 'react'
import {Route, routerRedux, Switch} from 'dva/router'
import dynamic from 'dva/dynamic'
import App from './routes/app'
import {LocaleProvider} from 'antd'
import zh_CN from 'antd/es/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
import {config} from "./utils"
import {Helmet} from "react-helmet"

moment.locale('zh-cn')

const {ConnectedRouter} = routerRedux

const Routers = function ({history, app}) {
  const routes = [
    {
      path: '/login',
      models: () => [require('./models/login')],
      component: () => require('./routes/login/'),
    },
    {
      path: '/group-apply',
      models: () => [require('./models/groupapply')],
      component: () => require('./routes/groupapply/submit'),
    },
    {
      path: '/group-apply/list',
      models: () => [require('./models/groupapplylist')],
      component: () => require('./routes/groupapply/list'),
    },
    {
      path: '/ticket',
      models: () => [require('./models/ticket')],
      component: () => require('./routes/ticket'),
    },
    {
      path: '/ticket/guide',
      component: () => require('./routes/ticket/guide'),
    },
    {
      path: '/ticket/:productId',
      models: () => [require('./models/ticketsubmit')],
      component: () => require('./routes/ticket/submit'),
    },
    {
      path: '/ticket/order/:orderId',
      models: () => [require('./models/ticketorder')],
      component: () => require('./routes/ticket/order'),
    },
    {
      models: () => [require('./models/home')],
      component: () => require('./routes/home/'),
    },
  ]

  return (
    <ConnectedRouter history={history}>
      <LocaleProvider locale={zh_CN}>
        <App>
          <Helmet>
            <title>{config.title}</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
          </Helmet>
          <Switch>
            {
              routes.map(({path, ...dynamics}, key) => (
                <Route key={key}
                       exact
                       path={path}
                       component={dynamic({
                         app,
                         ...dynamics,
                       })}
                />
              ))
            }
          </Switch>
        </App>
      </LocaleProvider>
    </ConnectedRouter>
  )
}

export default Routers
